import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=5129c28b&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=5129c28b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5129c28b",
  null
  
)

export default component.exports
import {QItem,QInput,QIcon,QBtn,QTooltip,QField} from 'quasar'
component.options.components = Object.assign({QItem,QInput,QIcon,QBtn,QTooltip,QField}, component.options.components || {})
